// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2678B","col":"styles_col__1ePLG"};